import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AppShell from "@/components/layout/AppShell";
import { api } from "@/lib/api";
import { useI18n } from "@/contexts/I18nContext";
import { FileText, Share2 } from "lucide-react";

/**
 * ReportsPage — real-data-only. Reports are generated from real platform
 * metrics. Until OAuth ingestion is wired, the page shows an empty-state.
 */
export default function ReportsPage() {
  const { lang } = useI18n();
  const nav = useNavigate();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    api.get("/reports/weekly").finally(() => setReady(true));
  }, []);

  if (!ready) {
    return (
      <AppShell>
        <div className="p-12 text-center text-muted-foreground">
          {lang === "ar" ? "جاري التحميل..." : "Loading…"}
        </div>
      </AppShell>
    );
  }

  return (
    <AppShell>
      <div className="mb-6">
        <h1 className="font-display text-3xl">{lang === "ar" ? "التقارير" : "Reports"}</h1>
        <p className="text-muted-foreground text-sm mt-1">
          {lang === "ar" ? "تقرير أسبوعي كامل قابل للتصدير." : "A full weekly performance report, ready to export."}
        </p>
      </div>

      <div data-testid="reports-empty-state" className="nx-card p-10 md:p-14 text-center max-w-2xl mx-auto animate-fade-in-up">
        <div className="w-16 h-16 rounded-sm bg-primary/5 text-primary flex items-center justify-center mx-auto mb-5">
          <FileText className="w-7 h-7" />
        </div>
        <h2 data-testid="reports-empty-headline" className="font-display text-2xl md:text-3xl mb-3">
          {lang === "ar" ? "لا يوجد تقرير بعد" : "No report yet"}
        </h2>
        <p className="text-muted-foreground mb-8 leading-relaxed">
          {lang === "ar"
            ? "سيتم إنشاء تقريرك الأسبوعي تلقائيًا بمجرد ربط أول حساب اجتماعي."
            : "Your weekly report will be generated automatically once you connect your first social account."}
        </p>
        <button
          data-testid="reports-connect-cta"
          onClick={() => nav("/app/social")}
          className="nx-btn-accent inline-flex items-center gap-2"
        >
          <Share2 className="w-4 h-4" /> {lang === "ar" ? "اربط حساباتك الآن" : "Connect a social account"}
        </button>
      </div>
    </AppShell>
  );
}
